import { mapOptions } from '../tools';
import Base from './Base';

/**
 * Navigation underline.
 */
class NavUnderline extends Base {
    /**
     * Construct
     * @param el {HTMLElement}
     */
    constructor(el, options = {}) {
        super();
        this._defaultSettings = {
            namespace: 'main-nav',
        };
        this._customSettings = options;
        this.settings = mapOptions(this._defaultSettings, this._customSettings);
        this._line = document.createElement('li');
        this._line.classList.add(this.getNamespace('__line'));
        this.el = el;
        this.items = this.el.querySelectorAll(this.getNamespaceClass('__item'));
        this.items.forEach(el => {
            el.addEventListener('mouseenter', e => this._itemMouseEnterListener(e));
            el.addEventListener('click', () => {
                this.el.querySelectorAll('.active, .trail').forEach(active => {
                    active.classList.remove('active');
                    active.classList.remove('trail');
                });

                el.classList.add('active');
                el.querySelector('strong, a').classList.add('active');
                this._setOnActiveItem();
            });
        });

        this._updateProperties();

        this.el.appendChild(this._line);

        this.el.addEventListener('mouseleave', () => this._setOnActiveItem());

        window.addEventListener('delayedResize', () => this._updateProperties());
        window.addEventListener('DOMContentLoaded', () => this._updateProperties());
        setTimeout(() => this._updateProperties(), 400);
    }

    /**
     * Handle mouse enter event on nav item.
     * @param e {MouseEvent}
     * @private
     */
    _itemMouseEnterListener(e) {
        this._updateProperties();
        this.setPositionOnItem(e.target.closest(this.getNamespaceClass('__item')));
    }

    /**
     * Update properties.
     * @private
     */
    _updateProperties() {
        this._navRect = this.el.getBoundingClientRect();

        this._setOnActiveItem();
    }

    /**
     * Set position on active item.
     * @private
     */
    _setOnActiveItem() {
        let selector = `${this.getNamespaceClass('__item.active')}, ${this.getNamespaceClass('__item.trail')}`;
        let active = this.el.querySelector(selector);

        if (active) {
            this.setPositionOnItem(active);
            this.el.classList.remove(this.getNamespace('--no-active-item'));
        } else {
            this.el.classList.add(this.getNamespace('--no-active-item'));
        }
    }

    /**
     * Set position vars on specified item.
     * @param el {HTMLElement}
     */
    setPositionOnItem(el) {
        const rect = el.getBoundingClientRect();

        this.el.style.setProperty('--item-width', `${el.scrollWidth}px`);
        this.el.style.setProperty('--item-start', `${rect.left - this._navRect.left}px`);
    }
}

export default NavUnderline;
